import { IAppState } from '../../store';

export const selectRealtorRealtyUserId = (state: IAppState) => Number(state.realtor?.realtyUserId);
